var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.75H6.25C5.91848 17.75 5.60054 17.6183 5.36612 17.3839C5.1317 17.1495 5 16.8315 5 16.5V14.625H6.25V16.5H13.75V1.5H6.25V3.375H5V1.5C5 1.16848 5.1317 0.850537 5.36612 0.616116C5.60054 0.381696 5.91848 0.25 6.25 0.25H13.75C14.0815 0.25 14.3995 0.381696 14.6339 0.616116C14.8683 0.850537 15 1.16848 15 1.5V16.5C15 16.8315 14.8683 17.1495 14.6339 17.3839C14.3995 17.6183 14.0815 17.75 13.75 17.75Z",
    fill: "#1D1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61875 11.8687L8.85625 9.625H0V8.375H8.85625L6.61875 6.13125L7.5 5.25L11.25 9L7.5 12.75L6.61875 11.8687Z",
    fill: "#1D1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.277a68634005f8b0406e0e4855613c0e.svg";
export { ForwardRef as ReactComponent };